export default class HashLocalStorage {
  public getItem(key: string): string | undefined | null {
    const item = window.localStorage.getItem(key);
    if (!item) { return item; }
    try {
      const value = atob(item);
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }
  public setItem(key: string, value: any) {
    window.localStorage.setItem(key, btoa(JSON.stringify(value)));
  }
  public removeItem(key: string) {
    window.localStorage.removeItem(key);
  }
}
